import '@horde/ui-tokens/tokens.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { captureErrors } from './lib/report';
import { initNative } from './native';
import { unlockAudio } from './sound';
import './styles/app.css';
import './styles/comic.css';

captureErrors();
void initNative();
if (import.meta.env.DEV) void import('./dev/loadReport').then((m) => m.loadReportFromUrl());
for (const ev of ['pointerdown', 'keydown', 'touchstart'] as const) {
  window.addEventListener(ev, unlockAudio, { passive: true });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
